/* Sternenbaum — Scroll-Aufbau und Einblenden. Laeuft einmal pro Seite,
   auch wenn mehrere Abschnitte das Skript einbinden. */
(function () {
  if (window.sbGestartet) return;
  window.sbGestartet = true;

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Wer weniger Bewegung eingestellt hat, bekommt das Titelvideo angehalten */
  function videoRuhig(wurzel) {
    if (!ruhig) return;
    wurzel.querySelectorAll('.sb-hero video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
  }
  videoRuhig(document);

  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('sb-js');

  function einblenden(wurzel) {
    var elemente = wurzel.querySelectorAll('.sb-einblenden:not(.ist-sichtbar)');
    if (ruhig) { elemente.forEach(function (e) { e.classList.add('ist-sichtbar'); }); return; }
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ist-sichtbar'); beobachter.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    elemente.forEach(function (e) { beobachter.observe(e); });
  }

  function aufbau(wurzel) {
    wurzel.querySelectorAll('[data-sb-aufbau]').forEach(function (abschnitt) {
      if (abschnitt.dataset.sbBereit) return;
      abschnitt.dataset.sbBereit = '1';
      var schritte = abschnitt.querySelectorAll('.sb-schritt');
      var bilder = abschnitt.querySelectorAll('.sb-aufbau__bild');
      var balken = abschnitt.querySelector('.sb-hoehe__balken');
      var wert = abschnitt.querySelector('.sb-hoehe__wert');
      var max = parseFloat(abschnitt.dataset.sbMax) || 148;

      function zeige(i) {
        schritte.forEach(function (s, j) { s.classList.toggle('ist-aktiv', i === j); });
        bilder.forEach(function (b, j) { b.classList.toggle('ist-aktiv', i === j); });
        var cm = parseFloat(schritte[i].dataset.hoehe) || 0;
        var anteil = Math.min(100, cm / max * 100) + '%';
        if (balken) balken.style.height = anteil;
        if (wert) { wert.style.bottom = anteil; wert.textContent = schritte[i].dataset.hoeheText || ''; }
      }

      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) zeige(Array.prototype.indexOf.call(schritte, e.target));
        });
      }, { rootMargin: '-40% 0px -40% 0px' });
      schritte.forEach(function (s) { beobachter.observe(s); });
      if (schritte.length) zeige(0);
    });
  }

  function start(wurzel) { videoRuhig(wurzel); einblenden(wurzel); aufbau(wurzel); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else { start(document); }

  /* Theme-Editor: neu geladene Abschnitte wieder anwerfen */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
